<template>
  <f7-page>
    <splash-screen v-if="!error"></splash-screen>
    <div v-else class="boot-error">
      <h2 class="boot-error__title">تعذر تشغيل التطبيق</h2>
      <p class="boot-error__message">حدث خطأ أثناء التهيئة. يرجى إعادة المحاولة.</p>
      <f7-button fill large @click="reload">إعادة المحاولة</f7-button>
    </div>
  </f7-page>
</template>
<script setup>
import SplashScreen from '@/pages/SplashScreen.vue';

defineProps({
  error: { type: [Error, Object, String], default: null },
});

function reload() {
  window.location.reload();
}
</script>

<style scoped>
.boot-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  text-align: center;
  gap: 12px;
}

.boot-error__title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.boot-error__message {
  font-size: 14px;
  color: var(--f7-text-color-secondary, #6b7280);
  margin: 0 0 12px;
}
</style>
